import "./WhatWeDo.css";

export default function WhatWeDoHero() {
    return (
        <>
            <section className="page-banner">
            <img 
                src="/what-we-do-banner.png" 
                alt="What We Do"
                className="banner-image"
            />
        </section>

            <section className="what-container">

                <div className="what-image">
                    <img
                        src="/what-we-do.jpeg"
                        alt="Paper Products"
                    />
                </div>

                <div className="what-content">

                    <span className="section-tag">
                        OUR EXPERTISE
                    </span>

                    <h2>
                        Everything You Need For Your
                        <span> Paper Requirements</span>
                    </h2>

                    <p>
                        RelyOnne UK Limited supplies a comprehensive range of
                        paper, board and packaging products to commercial,
                        industrial and retail customers throughout the United
                        Kingdom.
                    </p>

                    <p>
                        From office paper and printing materials to specialist
                        packaging boards and industrial paper solutions, we
                        source products from trusted manufacturers to ensure
                        consistent quality and competitive pricing.
                    </p>

                    <p>
                        Our experienced team works closely with every customer to
                        understand their requirements and recommend products that
                        deliver the best value for their business.
                    </p>

                </div>

            </section>
        </>
    );
}